import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ContactForm from '../components/contactform/ContactForm';
import ProductCard from '../components/productCard/ProductCard';
import SizingModal from '../components/sizingModal/SizingModal';
import useRevealOnScroll from '../hooks/useRevealOnScroll';
import useProductStore from '../states/ProductStore';
import styles from '../styles/Home.module.css';

export default function Home() {
  const [sizeGuide, setSizeGuide] = useState(null);
  const { hash } = useLocation();
  const products = useProductStore((state) => state.products);
  const displayProducts = [...products].sort((firstProduct, secondProduct) => {
    const productRank = (product) => /quarter|q-?zip/i.test(product?.name ?? '') ? 0 : 1;
    return productRank(firstProduct) - productRank(secondProduct);
  });

  useRevealOnScroll();

  useEffect(() => {
    if (!hash) return;

    const previousScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';

    if (hash === '#top') {
      window.scrollTo({ top: 0, behavior: 'auto' });
    } else {
      document.getElementById(hash.slice(1))?.scrollIntoView({
        behavior: 'auto',
        block: 'start',
      });
    }

    document.documentElement.style.scrollBehavior = previousScrollBehavior;
  }, [hash, products]);

  return (
    <>
      <main id="top">
        <section className={styles.garments} id="archives">
          {displayProducts.map((product, index) => (
            <ProductCard
              key={product.id}
              product={product}
              index={index}
              openSizeGuide={(selectedProduct, selectedSize) => setSizeGuide({ product: selectedProduct, selectedSize })}
            />
          ))}
        </section>
        <div className="data-ribbon">
          <span>Studio open</span>
          <span className="hide-mobile">Small runs, natural fibers, quiet details</span>
          <span>M80 &copy; {new Date().getFullYear()}</span>
        </div>
        <ContactForm />
      </main>
      <SizingModal selection={sizeGuide} close={() => setSizeGuide(null)} />
    </>
  );
}
